<template>
  <!-- banner -->
  <div class="m-banner">
    <img
      v-if="extraItem.extras('banner.display')"
      :src="extraItem.extras('banner.src')"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: ["extras"],
};
</script>

<style scoped></style>
